import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  club: null,
};

const clubSlice = createSlice({
  name: 'club',
  initialState,
  reducers: {
    resetClub() {
      return initialState;
    },
    addClub(state, action) {
      state.club = action.payload;
    },
    updateAvatar(state, action) {
      if (state.club) {
        state.club.avatar = action.payload;
      }
    },
    updatePhotos(state, action) {
      if (state.club) {
        if (!Array.isArray(state.club.photos)) {
          state.club.photos = [];
        }
        state.club.photos.push(action.payload);
      }
    },
    setPhotos(state, action) {
      if (state.club) {
        state.club.photos = action.payload;
      }
    },
    removePhoto(state, action) {
      if (state.club && Array.isArray(state.club.photos)) {
        state.club.photos.splice(action.payload, 1);
      }
    },
  },
});

export const {
  resetClub,
  addClub,
  updateAvatar,
  updatePhotos,
  setPhotos,
  removePhoto,
} = clubSlice.actions;

export default clubSlice.reducer;
